<template>
    <el-dialog
      class="detail-info-dia"
      title="录入证书编号信息"
      :visible.sync="isShow"
      :close-on-click-modal="false"
      :width="dw"
      top="12vh">
        <vue-scroll :ops="vuescrollOpt">
        <el-form :model="record" label-width="90px" class="blackListForm" :rules="formRules" ref="form" style="max-height:625px">
            <el-form-item label="姓名" >
                <el-input v-model="record.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="证书编号" >
                
                
                
                <el-row style="display: flex;align-items: flex-end;">
                    <el-col :span="3" >
                        <p class="intro">{{Info.level}}</p>
                    </el-col>
                    <el-form-item prop="year" style="width: 140px;">
                    <el-col>
                        <el-input
                          
                          v-model.trim="record.year"
                          class="zz-input"
                        ></el-input>
                    </el-col>
                    </el-form-item>
                    <el-col :span="2" >
                        <p class="intro">/</p>
                    </el-col>
                    <el-form-item prop="zsNum" style="width: 160px;">
                    <el-col>
                        <el-input
                          
                          v-model.trim="record.zsNum"
                          class="zz-input"
                        ></el-input>
                    </el-col>
                    </el-form-item>
                    
                </el-row>
                <!--<el-input placeholder="请输入证书编号" v-model="record.certificate_number"></el-input>-->
            </el-form-item>
            <!--<el-form-item label="证书文件">-->
                <!--<el-upload-->
                  <!--ref="uploadFile"-->
                  <!--action="/api/enroll/upload_enroll_file.json"-->
                  <!--:file-list="record.files"-->
                  <!--:headers="fileUpHeaders"-->
                  <!--:data="fileUpParam"-->
                  <!--:before-upload="beforeUpload"-->
                  <!--:on-progress="isUping"-->
                  <!--:on-error="uploadError"-->
                  <!--:on-success="uploadSuccess"-->
                  <!--:on-remove="fileRemove"-->
                  <!--:limit="1"-->
                  <!--:on-exceed="(files, fileList) => handleExceed(files, fileList, 1)"-->
                <!--&gt;-->
                    <!--<el-button type="primary">点击上传</el-button>-->
                    <!--<div slot="tip" class>只能上传一个PDF文件，且文件大小不能超过50M。</div>-->
                <!--</el-upload>-->
            <!--</el-form-item>-->
            <div class="btns">
                <el-button type="primary" @click="sureSubmit" :loading="loading" :disabled="loading">确定</el-button>
                <el-button type="danger" @click="cancel">取消</el-button>
            </div>
        </el-form>
        </vue-scroll>
    </el-dialog>
</template>

<script>
  import { storageData } from "@/assets/js/storage";
  import createScrollOpt from "@/assets/js/vuescrollOption";
  import { student_certificate_save } from "@/api/system_manager/api";
  import {
    high_player_certification_info,
  } from "@/api/system_manager/api"
  export default {
    name: "addMaterials",
    data(){
      return{
        loading:false,
        notEdit:false,
        submitDisabled: false,
        vuescrollOpt: createScrollOpt(),
        fileUpHeaders: { "X-Token": storageData.getToken(),"X-UserType":storageData.getUserType() },
        fileUpParam: {},
        record:{
          name: '',
          year:'',
          zsNum:'',
          certificate_number: '',
          uid: '',
          c_id: '',
          files: [],
        },
        formRules:{
          year:[
            {
              required: true,
              validator: (rule, value, callback) => {
                if (value) {
                  const  reg = /^[0-9]{2}$/;
                  const isPass = reg.test(value)
                  if(isPass) {
                    callback()
                  } else {
                    callback(new Error('证书编号格式错误'));
                  }
                } else {
                  callback(new Error('请输入证书编号'));
                }
              },
              trigger: "blur"
            }
          ],
          zsNum:[
            {
              required: true,
              validator: (rule, value, callback) => {
                if (value) {
                  const  reg = /^[0-9]{4}$/;
                  const isPass = reg.test(value)
                  if(isPass) {
                    callback()
                  } else {
                    callback(new Error('证书编号格式错误'));
                  }
                } else {
                  callback(new Error('请输入证书编号'));
                }
              },
              trigger: "blur"
            }
          ],
        }
      }
    },
    created(){
      if (Object.keys(this.Info).length>0){
        Object.assign(this.record,this.Info)
        
        if(this.Info.certificate_number){
          const after = this.Info.certificate_number.split('-')[1];
          this.record.year = after.split('/')[0];
          this.record.zsNum = after.split('/')[1];
        }
      }
      this.request();
      
    },
    props:{
      showAddDialog:{
        type:Boolean,
        required:true,
        default: false,
      },
      Info:{
        type:Object,
        required :false
      },
      dw:{
        default:'500px',
        required:false,
      }
    },
    computed: {
      isShow: {
        get(){
          return this.showAddDialog;
        },
        set(bool){
          // 参数1：是否显示弹窗
          // 参数2：是否点击确定按钮
          this.$emit("hideTips", bool, false);
        }
      },
    },
    methods:{
      sliceYear() {
        if (String(this.record.year).length > 2) {
          this.record.year = Number(String(this.record.year).slice(0, 2));
        }
      },
      sliceZsNum() {
        if (String(this.record.zsNum).length > 4) {
          this.record.zsNum = Number(String(this.record.zsNum).slice(0, 4));
        }
      },
      request() {
        if(this.Info.ducoment_address){
          this.record.files.push({ url: this.Info.ducoment_address, name: this.Info.ducoment_file })
        }else{
          this.record.files = [];
        }
      },
      beforeUpload(file) {
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error("文件大小不能超过50M!");
          return false;
        }
        if (!/^.*\.(pdf)$/i.test(file.name)) {
          this.$message.error("请上传pdf格式的文件!");
          return false;
        }
        let param = {
          document: file
        };
        for (const key in param) {
          if (param.hasOwnProperty(key)) {
            this.$set(this.fileUpParam, key, param[key]);
          }
        }
      },
      isUping() {
        this.submitDisabled = true;
      },
      uploadError() {
        this.submitDisabled = false;
      },
      uploadSuccess(res) {
        this.submitDisabled = false;
        if (Number(res.status) === 0) {
          this.record.files.push({ url: res.result.document_url, name: res.result.document_name })
        } else {
          this.$nextTick(() => { });
          this.$message.error(res.msg);
        }
      },
      fileRemove(file, fileList) {
        this.record.files = fileList;
      },
      handleExceed(file, fileList, max){
        this.$message.warning(`当前最多允许上传数量${max}`)
      },
      cancel(){
        this.isShow=false;
      },
      sureSubmit(){
        this.$refs["form"].validate((valid) => {
          if (valid){
            
            // 2024.01.04 改为非必传的了
//            if(this.record.files.length===0){
//              this.$message.error('请上传证书文件')
//              return
//            }
            
            this.loading=true;
            const certificate_number = this.Info.level+this.record.year+"/"+this.record.zsNum;
            const info = {
              c_id:this.Info.c_id,
              uid:this.Info.uid,
              certificate_number:certificate_number,
              file_list: JSON.stringify(this.record.files.map(item => ({
                document_url: item.url,
                document_name: item.name,
              })))
            }
            student_certificate_save(info).then(res=>{
              if (res.data.status===0){
                this.loading=false;
                this.$emit("hideTips", false, true);
              }else{
                this.$message.error(res.data.msg);
                this.loading=false
              }
            }).catch(error=>{
              this.loading=false
            })
          } else{
            this.$message.error('请正确填写所有数据')
          }
        })
        
      }
    },
    components:{
      "image-up": () => import("@/components/UpImage/UpImage"),
    }
  }
</script>

<style scoped lang="stylus">
    .blackListForm
        padding-right 20px
        .btns
            display flex
            justify-content: center
        .zz-input {
            .el-input__inner {
                border: none;
                border-radius: 0;
                border-bottom: 1px solid rgba(0, 0, 0 0.1);
                // height: 30px;
                padding: 0;
            }
        }
        .intro {
            font-weight: bold;
            text-align: center;
            align-items: flex-end;
        }
    .el-dialog__body{
        padding-right: 0;
    }
</style>
